require('../../modules/es.date.get-year');
require('../../modules/es.date.now');
require('../../modules/es.date.set-year');
require('../../modules/es.date.to-gmt-string');
require('../../modules/es.date.to-iso-string');
require('../../modules/es.date.to-json');
require('../../modules/es.date.to-string');
require('../../modules/es.date.to-primitive');
var path = require('../../internals/path');

module.exports = path.Date;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/date/index.js
// module id = 235
// module chunks = 0